import React, {useState} from  'react';
import styled from 'styled-components';
import { FiX,FiSend } from "react-icons/fi";

const FloatingInputContainer = styled.div`
    position: fixed;
    bottom: 0;
    right: 40px;
    z-index: 1;
    background: #222;
    width: 400px;
    height: 145px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
`;

const FloatingInputNav = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 5px 20px;
    color: #fff;
    background-color: ${props => props.theme.backgroundColors.default};
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
`;

const CloseButton = styled.button`
    background-color: transparent;
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    font-weight: ${props => props.theme.font.weight.bold};
`;

const ChatInputArea = styled.div`
    display: flex;
    position: relative;
    height: 100px;
    padding: 0px 20px 10px 20px;
`;

const ChatInput = styled.textarea`
    height: 100%;
    width: 100%;
    padding: 5px 60px 5px 10px;
    font-size: 16px;
    border: none;
    outline: none;
    font-family: inherit;
    background-color: #3A3B3C;
    color: #fff;
    border-radius: 10px;
    resize: none;
    &::-webkit-scrollbar {
        display: none;
    }
    &:focus{
        border: none;
        outline: none;
    }
`;

const SendButton = styled.button`
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    font-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${props => props.theme.colors.default};
    outline: none;
    cursor: pointer;
`;

const FloatingChatInput = ({handleChatInputToogle,handleSendMessage}) => {
    const [input,setInput] = useState('');

    const handleSend = (e) => {
        handleSendMessage(input);
        setInput('');
    }
    return(
        <FloatingInputContainer>
            <FloatingInputNav>
                <span>চ্যাট শুরু করতে ইনপুট বক্সে লিখা শুরু করুন!</span>
                <CloseButton onClick={handleChatInputToogle}><FiX/></CloseButton>
            </FloatingInputNav>
            <ChatInputArea>
                <ChatInput onChange={e => setInput(e.target.value)} value={input}/>
                <SendButton onClick={handleSend}><FiSend/></SendButton>
            </ChatInputArea>
        </FloatingInputContainer>
    )
}

export default FloatingChatInput;